exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-ul > .uu5-bricks-header,\n.uu5-bricks-ol > .uu5-bricks-header {\n  /* delete ul padding */\n  margin-left: -40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/ul-ol.less
// module id = 283
// module chunks = 0